import { Router } from "express";

import { helpFeedbackController } from "../controllers/help-feedback-controller";
import { authenticate, createRateLimit } from "../middleware/auth-middleware";
import { requireRole } from "../middleware/role-middleware";

const router = Router();

// Environment-aware rate limiting
const generalRateLimit = createRateLimit.general();

/**
 * @route   POST /api/v1/help-feedback
 * @desc    Submit help request or feedback
 * @access  Private
 */
router.post("/", authenticate, generalRateLimit, (req, res) =>
  helpFeedbackController.submitHelpFeedback(req, res),
);

/**
 * @route   GET /api/v1/help-feedback
 * @desc    Get all help/feedback for authenticated user
 * @access  Private
 */
router.get("/", authenticate, generalRateLimit, (req, res) =>
  helpFeedbackController.getHelpFeedback(req, res),
);

/**
 * School Help/Feedback Routes
 */

/**
 * @route   GET /api/v1/school/help-feedback
 * @desc    Get all help/feedback for school panel
 * @access  Private (School Admin)
 */
router.get(
  "/school/help-feedback",
  authenticate,
  requireRole(["school"]),
  generalRateLimit,
  (req, res) => helpFeedbackController.getSchoolHelpFeedback(req, res),
);

/**
 * @route   PUT /api/v1/school/help-feedback/:id/respond
 * @desc    Respond to help/feedback
 * @access  Private (School Admin)
 */
router.put(
  "/school/help-feedback/:id/respond",
  authenticate,
  requireRole(["school"]),
  generalRateLimit,
  (req, res) => helpFeedbackController.respondToHelpFeedback(req, res),
);

export default router;
